import * as React from 'react';
import { Box, Button, Grid, MenuItem, Paper, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import DashboardCustomer from './components/dashboard/dashboard_customer';
const config = {
  headers: {
    "Access-Control-Allow-Origin": "*",
    'Content-Type': 'application/json',
    "Access-Control-Allow-Methods": "GET,PUT,POST,OPTIONS,ANY",
    "Access-Control-Allow-Credentials": true,
    "Access-Control-Allow-Headers": "Origin, Content-Type, Accept, Authorization, X-Requested-With, privatekey"
  }
};


const DMSMainPage = () => {
  const user = JSON.parse(sessionStorage.getItem("userProfile"));
  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  var storedValue = sessionStorage.getItem('clickedInstrument')
  const typeData = JSON.stringify({ type: 'ViewAll' });
  useEffect(() => {
    var response = JSON.parse(sessionStorage.getItem("experimentData"))
    setData(response);
    setFilterData(response);
  }, []);
  return (
    <Grid container flex={3} p={1} sx={{ height: '100%', width: '100%', marginTop: '2' }}>
      <Stack direction={"column"} sx={{ width: '100%' }} p={1} gap={2} >
        <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between' }} >
        </Box>
        <DashboardCustomer ></DashboardCustomer>
      </Stack>
    </Grid>
  )
}

export default DMSMainPage;